<template>
  <div>

    <form>
      <div class="mb-3">
        <input type="email" :class="toInputClass" placeholder="Do" v-model="editorMailTo" aria-describedby="to-email-input-feedback"/>
        <div class="invalid-feedback" id="to-email-input-feedback">
          Wpisz poprawny adres email.
      </div>
      </div>
      <div class="mb-3">
        <input type="email" :class="ccInputClass" placeholder="DW" v-model="editorMailCc" aria-describedby="cc-email-input-feedback"/>
        <div class="invalid-feedback" id="cc-email-input-feedback">
          Wpisz poprawny adres email.
        </div>

      </div>

      <div class="mb-3">
        <input type="text" :class="subjectInputClass" placeholder="Temat" v-model="editorSubject" aria-describedby="subject-input-feedback"/>
          <div class="invalid-feedback" id="subject-input-feedback">
            Wpisz temat wiadomości.
          </div>

      </div>


      <div class="mb-3">
        <QuillEditor contentType="html" theme="snow" :enable="true" toolbar="full" v-model:content="editorData" placeholder="Wpisz treść wiadomości" style="min-height:200px;"/>
      </div>

      <!--      Add attachment with icon-->
      <div class="mb-3">
<!--        <input type="text" class="form-control" placeholder="Załącznik" v-model="mailAttachmentName" disabled/>-->
<!--        <i class="fas fa-paperclip"></i>-->

        <div class="input-group">
          <input type="text" class="form-control" placeholder="Załącznik" v-model="editorMailAttachmentName" disabled/>
          <button class="btn btn-outline-secondary" type="button" id="button-addon2">
            <i class="fas fa-paperclip"></i>
          </button>
        </div>
      </div>

    </form>
    <div class="container">
      <div class="d-flex justify-content-start">
        <b-button variant="primary" @click="sendMail()">
          Wyślij
          <i class="fab fa-telegram-plane ms-1"></i>
        </b-button>
      </div>
     <div class="d-flex justify-content-end">
       <b-button variant="secondary" @click="cancelMail()">Anuluj</b-button>
     </div>


    </div>
  </div>


</template>

<script>

import {BButton} from "bootstrap-vue-next";
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
export default {
  name: "CommonEmailSendMessageForm",
  components: { QuillEditor, BButton },
  emits: ["onSendMail", "onCancelMail"],
  props: {
    mailMessage: String,
    mailSubject: String,
    mailTo: String,
    mailCc: String,
    mailBcc: String,
    mailAttachmentName: String,

  },
  data() {
    return {
      editorData: "<p>Treść wiadomości.</p>",
      editorSubject: "",
      editorMailTo: "",
      editorMailCc: "",
      editorMailBcc: "",
      editorMailAttachmentName: "",


      toInputClass: "form-control",
      ccInputClass: "form-control",
      bccInputClass: "form-control",
      subjectInputClass: "form-control",
    };
  },
  methods: {
    cancelMail() {
     this.$emit("onCancelMail");
    },
    sendMail() {
      // validate inputs Do, DW, Temat, Treść
      var isValid = true;

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


      if (this.editorMailTo == null || this.editorMailTo.length === 0) {
        this.toInputClass = "form-control is-invalid";
        isValid = false;
      } else {

        const mailToList = this.editorMailTo.split(",").map((item) => item.trim());
        for (let i = 0; i < mailToList.length; i++) {
          if (!emailRegex.test(mailToList[i])) {
            this.toInputClass = "form-control is-invalid";
            isValid = false;
            break;
          }else{
            this.toInputClass = "form-control";
          }
        }

      }

      if (this.editorMailCc == null || this.editorMailCc.length === 0) {
        // cc is not required
        this.ccInputClass = "form-control";
        isValid = true;
      } else {
        const mailBccList = this.editorMailBcc.split(",").map((item) => item.trim());
        for (let i = 0; i < mailBccList.length; i++) {
          if (!emailRegex.test(mailBccList[i])) {
            this.ccInputClass = "form-control is-invalid";
            isValid = false;
            break;
          }else{
            this.ccInputClass = "form-control";
          }
        }
      }


      if (this.editorMailBcc == null || this.editorMailBcc.length === 0) {
        // bcc is not required
        this.bccInputClass = "form-control";
        isValid = true;
      } else {
        const mailBccList = this.editorMailBcc.split(",").map((item) => item.trim());
        for (let i = 0; i < mailBccList.length; i++) {
          if (!emailRegex.test(mailBccList[i])) {
            this.bccInputClass = "form-control is-invalid";
            isValid = false;
            break;
          }else{
            this.bccInputClass = "form-control";
          }
        }
      }

      if (this.editorSubject == null || this.editorSubject.length === 0) {
        this.subjectInputClass = "form-control is-invalid";
        isValid = false;
      } else {
        this.subjectInputClass = "form-control";
      }

      if(!isValid){
        return;
      }

      // separate to, cc, and bcc with comma and space
      const mailToList = this.editorMailTo.split(",").map((item) => item.trim());
      var mailCcList = []
      if(this.editorMailCc != null && this.editorMailCc.length > 0){
        mailCcList = this.editorMailCc.split(",").map((item) => item.trim());
      }

      var mailBccList = []
      if(this.editorMailBcc != null && this.editorMailBcc.length > 0){
        mailBccList = this.editorMailBcc.split(",").map((item) => item.trim());
      }


      this.$emit("onSendMail", {
        to: mailToList,
        cc: mailCcList,
        bcc: mailBccList,
        subject: this.editorSubject,
        content: this.editorData,
        attachments: [this.editorMailAttachmentName], // todo: handle multiple attachments
      });
    }
  },
  created() {
    if (this.mailMessage) {
      this.editorData = this.mailMessage;
    }
    if (this.mailSubject) {
      this.editorSubject = this.mailSubject;
    }

    if (this.mailTo) {
      this.editorMailTo = this.mailTo;
    }

    if (this.mailCc) {
      this.editorMailCc = this.mailCc;
    }

    if (this.mailBcc) {
      this.editorMailBcc = this.mailBcc;
    }

    if (this.mailAttachmentName) {
      this.editorMailAttachmentName = this.mailAttachmentName;
    }
  }
};


</script>

<style scoped>
.container {
  display: flex;
  flex-wrap: wrap;
}

.container > div {
  flex: 50%; /* or - flex: 0 50% - or - flex-basis: 50% - */

  margin-bottom: 10px;
}
</style>
